import { Stack, TextField, Theme, Typography } from "@mui/material";
import { prefixClassName } from "@smartrr/shared/components/primitives";
import { typedLocalize } from "@smartrr/shared/utils/sharedTranslations/localize";
import React from "react";

import { LoginButton as StyledLogInButton, emailTextFieldStyles } from "../../../styles";
import { LoginError } from "../../../types";
import { AlertIcon } from "../../AlertIcon";
import { SignInFooter } from "../../SignInFooter";
import { SuccessCheckIcon } from "../../SuccessCheckIcon";

const renderInputProps = (email?: string, isEmailValid?: boolean) => {
  return {
    endAdornment: email?.length && isEmailValid ? <SuccessCheckIcon /> : email ? <AlertIcon /> : undefined,
  };
};
export interface IPasswordlessLoginForm {
  handleEmailInputChange: (value: string) => void;
  handleEmailInputBlur: (value: string) => void;
  email: string;
  shopifyDomain: string;
  isEmailValid: boolean | undefined;
  requestMagicLink: (email?: string, shopifyDomain?: string) => Promise<void>;
  theme: Theme;
  loginError?: LoginError;
}

const PasswordlessLoginForm = ({
  requestMagicLink,
  email,
  shopifyDomain,
  isEmailValid,
  handleEmailInputChange,
  handleEmailInputBlur,
  theme,
  loginError,
}: IPasswordlessLoginForm) => {
  return (
    <section>
      <header>
        <Typography variant="h2" className={prefixClassName("magic-link-header")} pb={"20px"}>
          {typedLocalize("passwordlessLogin.enterEmail")}
        </Typography>
      </header>
      <main>
        <form onSubmit={() => requestMagicLink(email, shopifyDomain)} style={{ width: "100%" }}>
          <Stack gap="15px" sx={{ alignItems: "center" }}>
            <TextField
              autoComplete="email"
              type="email"
              className={prefixClassName("magic-link-input")}
              placeholder={typedLocalize("passwordlessLogin.emailPlaceholder")}
              InputProps={renderInputProps(email, isEmailValid)}
              value={email}
              onChange={e => handleEmailInputChange(e.target.value)}
              onBlur={() => handleEmailInputBlur(email)}
              sx={emailTextFieldStyles(theme, isEmailValid!)}
            />
            <StyledLogInButton
              theme={theme}
              className={prefixClassName("otp-submit-button")}
              type="submit"
              variant="contained"
              disabled={!isEmailValid}
            >
              {typedLocalize("passwordlessLogin.loginWithMagicLink")}
            </StyledLogInButton>
          </Stack>
        </form>
      </main>
      <SignInFooter loginError={loginError} shopifyDomain={shopifyDomain!} />
    </section>
  );
};

export default PasswordlessLoginForm;
